module.exports = __webpack_public_path__ + "media/fr.5752a1ee.mp3";